var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"navigation-bar"},[_c('ul',{staticClass:"wrapper"},_vm._l((_vm.menuList),function(item,index){return _c('li',{key:index,class:_vm.activeMenu === item.router ? 'item active' : 'item',on:{"click":function($event){return _vm.tabClick(index)}}},[_vm._v(" "+_vm._s(item.name)+" ")])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }